var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Subject } from '@/models/Subject';
import AsyncSelect from '@/components/async-select/AsyncSelect';
import { RolesEnum } from '@/items/Roles';
// import { Options } from '@/components/mi-dialog/MiDialog';
let CurriculumDialog = class CurriculumDialog extends Vue {
    constructor() {
        super(...arguments);
        this.selectedSubject = null;
        this.subjects = [];
        this.subjectSearch = '';
        this.isLoading = false;
    }
    mounted() { }
    clear() {
        this.selectedSubject = null;
    }
    searchChanged(search, oldSearch) {
        if (typeof search !== 'string' || search.length === 0) {
            this.subjects = [];
            return;
        }
        if (search.length > 2) {
            this.$debounce('getSubjects');
        }
    }
    getSubjects() {
        this.isLoading = true;
        new Subject()
            .filter({ depth: 2, search: this.subjectSearch, archived: false })
            .include(['level', 'period', 'parent'])
            .all()
            .then((subjects) => {
            this.$nextTick(() => {
                this.$set(this, 'subjects', subjects);
            });
            this.isLoading = false;
        })
            .catch(() => {
            this.isLoading = false;
        });
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([
            RolesEnum.ADMIN,
            RolesEnum.ROOT,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
            RolesEnum.TEACHER,
        ]);
    }
    close() {
        this.$emit('input', false);
    }
};
__decorate([
    Watch('subjectSearch'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], CurriculumDialog.prototype, "searchChanged", null);
CurriculumDialog = __decorate([
    Component({
        components: {
            AsyncSelect,
        },
    })
], CurriculumDialog);
export default CurriculumDialog;
